import { apiRequest } from './client';
// API returns lowercase scope values, but frontend types expect uppercase
function normalizeFolder(folder) {
    return {
        ...folder,
        scope: folder.scope?.toUpperCase(),
    };
}
export async function getStudyFolders() {
    const folders = await apiRequest('GET', '/studyfolders');
    return folders.map(normalizeFolder);
}
export async function createStudyFolder(request) {
    // Send lowercase scope to API, normalize response to uppercase
    const apiPayload = {
        ...request,
        scope: request.scope.toLowerCase(),
    };
    const folder = await apiRequest('POST', '/studyfolders', apiPayload);
    return normalizeFolder(folder);
}
export async function updateStudyFolder(id, request) {
    const folder = await apiRequest('PATCH', `/studyfolders/${id}`, request);
    return normalizeFolder(folder);
}
export async function deleteStudyFolder(id) {
    return apiRequest('DELETE', `/studyfolders/${id}`);
}
export async function addStudiesToFolder(folderId, request) {
    return apiRequest('POST', `/studyfolders/${folderId}/studies`, request);
}
export async function removeStudyFromFolder(folderId, studyId) {
    return apiRequest('DELETE', `/studyfolders/${folderId}/studies/${encodeURIComponent(studyId)}`);
}
export async function reorderFolder(folderId, request) {
    return apiRequest('POST', `/studyfolders/${folderId}/reorder`, request);
}
export async function getFoldersForStudy(studyId) {
    const folders = await apiRequest('GET', `/studies/${encodeURIComponent(studyId)}/folders`);
    return folders.map(normalizeFolder);
}
